//當前收起狀態
localStorage.setItem('theme', 'true')
const theme = localStorage.getItem('theme')
const bool = (themeString) => {
  if (themeString === 'false') {
    return false
  } else {
    return true
  }
}
const themeReducer = (state = bool(theme), action) => {
  switch (action.type) {
    case 'CHANGE_THEME': {
      return action.payload
    }
    default:
      return state
  }
}
export default themeReducer